import React, { useState, useEffect } from 'react';
import store, { appraiserActions } from '@apply/adminStore';
import { AppraisalsApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { AppraiserFlagType } from '../common/constants/AppraiserFlagType';
import { BfiDataGrid, Column } from '../../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { onActionCellRender } from '../common/AppraiserFunctions';

const AppraisersTable = ({ gridStore, inactive = false }) => {
    const searchState = useSelector((state) => state.searchState);
    const appraisersApi = new AppraisalsApi.AppraisalsApi(applicationInsights);
    const { dispatch } = store;

    const [isAddressHeaderVisible, set_isAddressHeaderVisible] = useState(false);

    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = (criteria) =>
        inactive ? appraisersApi.getInActiveList(criteria) : appraisersApi.getActiveList(criteria);

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.application);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onAppraiserFlagRender = (e) => {
        switch (e.value) {
            case AppraiserFlagType.Retired:
                return (
                    <i
                        style={{ color: 'blue' }}
                        title='Appraiser is retired'
                    >
                        <FontAwesomeIcon icon={faFlag} />
                    </i>
                );
            case AppraiserFlagType.Preferred:
                return (
                    <i
                        style={{ color: 'green' }}
                        title='Appraiser is preferred'
                    >
                        <FontAwesomeIcon icon={faFlag} />
                    </i>
                );
            case AppraiserFlagType.Issue:
                return (
                    <i
                        style={{ color: 'gold' }}
                        title='Appraiser has had past issues'
                    >
                        <FontAwesomeIcon icon={faFlag} />
                    </i>
                );
            case AppraiserFlagType.Blacklisted:
                return (
                    <i
                        style={{ color: 'red' }}
                        title='Appraiser is blacklisted'
                    >
                        <FontAwesomeIcon icon={faFlag} />
                    </i>
                );
        }
    };

    const onAddressHeaderRender = (e) => {
        if (e.rowType !== 'header') {
            return null;
        }
        return (
            <>
                Property{' '}
                <button
                    className='link'
                    onClick={(event) => set_isAddressHeaderVisible(!isAddressHeaderVisible)}
                    style={{ cursor: 'pointer' }}
                >
                    {isAddressHeaderVisible ? <FontAwesomeIcon icon={faCaretDown} /> : <FontAwesomeIcon icon={faCaretRight} />}
                </button>
            </>
        );
    };

    const onCellDoubleClick = (e) => {
        if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
            return;
        }
        const id = e.data.id;
        dispatch(
            appraiserActions.setAppraiserModal({
                appraiserModal: { isOpen: true, appraiserId: id },
            })
        );
    };

    return (
        <>
            <BfiDataGrid
                gridType={GridSettingType.Appraisers}
                defaultPageSize={15}
                dataStore={dataStore}
                applicationInsights={applicationInsights}
                onCellDblClick={onCellDoubleClick}
                allowColumnResizing={true}
                allowReordering={true}
            >
                <Column
                    dataField='companyName'
                    caption='Company'
                    width={200}
                />
                <Column
                    dataField='appraiserFlagTypeId'
                    caption='Flg'
                    width={40}
                    cellRender={onAppraiserFlagRender}
                    alignment={'center'}
                />
                <Column
                    dataField='firstName'
                    caption='First Name'
                    width={150}
                />
                <Column
                    dataField='lastName'
                    caption='Last Name'
                    width={150}
                />
                <Column
                    dataField='email'
                    caption='Email'
                />
                <Column
                    dataField='phone'
                    caption='Phone'
                    width={120}
                />
                <Column
                    alignment={'left'}
                    allowSorting={false}
                    headerCellRender={onAddressHeaderRender}
                >
                    <Column
                        dataField='street'
                        caption='Street'
                        width={250}
                        allowReordering={false}
                    />
                    <Column
                        dataField='city'
                        caption='City'
                        width={120}
                        visible={isAddressHeaderVisible}
                        allowReordering={false}
                    />
                    <Column
                        dataField='state'
                        caption='State'
                        width={60}
                        visible={isAddressHeaderVisible}
                        allowReordering={false}
                    />
                    <Column
                        dataField='zipCode'
                        caption='Zip'
                        width={60}
                        visible={isAddressHeaderVisible}
                        allowReordering={false}
                    />
                    <Column
                        dataField='county'
                        caption='County'
                        width={100}
                        visible={isAddressHeaderVisible}
                        allowReordering={false}
                    />
                </Column>
                <Column
                    dataField='appraiserLicenseType'
                    caption='License'
                    width={100}
                />
                <Column
                    alignment='center'
                    cellRender={(e) => onActionCellRender(e, inactive)}
                    width={50}
                    allowReordering={false}
                    allowSorting={false}
                    allowResizing={false}
                    type='actions'
                    fixed={true}
                    fixedPosition={'right'}
                />
            </BfiDataGrid>
        </>
    );
};

export default AppraisersTable;
